import React from "react";
import { Link } from "@mui/material/";
import { useTranslation } from "react-i18next";
import config from "../../config";

const CameraLocationError = ({ message }) => {
    const { t } = useTranslation();

    return (
        <Link href={config.permissionsReadme} color="inherit">
            {`${message} ${t("tapForReadme")}`}
            <b>README</b>
        </Link>
    );
};

export default CameraLocationError;
